'use strict';

var imageClientLib = require('image-client-api/dist/imageClientApi');
var _ = require('lodash');

module.exports = {
    getImageClientLib: _.once(function () {
        imageClientLib.populateGlobalFeatureSupport();
        return imageClientLib;
    })
};
//# sourceMappingURL=imageClientApi.js.map